var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4ZM15.641 12.7694C17.075 11.673 18 9.94452 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 9.94452 6.92501 11.673 8.35901 12.7694C7.35354 13.2142 6.4285 13.8436 5.63604 14.636C5.02411 15.248 4.50935 15.939 4.10177 16.6851C3.34966 18.0619 3.65638 19.4657 4.5034 20.4584C5.3188 21.414 6.62502 22 8 22H16C17.375 22 18.6812 21.414 19.4966 20.4584C20.3436 19.4657 20.6503 18.0619 19.8982 16.6851C19.4907 15.939 18.9759 15.248 18.364 14.636C17.5715 13.8436 16.6465 13.2142 15.641 12.7694ZM12 14C10.1435 14 8.36301 14.7375 7.05025 16.0503C6.57425 16.5263 6.17394 17.0637 5.85696 17.6439C5.54999 18.2058 5.64902 18.7198 6.02481 19.1602C6.4322 19.6376 7.16584 20 8 20H16C16.8342 20 17.5678 19.6376 17.9752 19.1602C18.351 18.7198 18.45 18.2058 18.143 17.6439C17.8261 17.0637 17.4258 16.5263 16.9497 16.0503C15.637 14.7375 13.8565 14 12 14Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b992e998adfe8cd016f05fe28a8d4e14.svg";
export { ForwardRef as ReactComponent };